var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-button',{attrs:{"icon":_vm.$icons.filter,"title":"Setup filter rules"},on:{"action":_vm.setup}})}
var staticRenderFns = []

export { render, staticRenderFns }